export default __webpack_public_path__ + "static/media/0000-min.99b1545e.png";